// A mock function to mimic making an async request for data
export function fetchCount() {
  return fetch("/api/random/").then(response => response.json())
}
